import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomersComponent } from 'app/components/home/customers/customers.component';
import { DigitTypeEnum } from 'app/models';

@Component({
    selector: 'user-filter',
    templateUrl: './user-filter.component.html',
    styleUrls: ['./user-filter.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class UserFilterComponent implements OnInit {
    @Input()
    public visibleUserFilter: boolean = false;

    @Input()
    public customersComponent!: CustomersComponent;

    @Output() changedVisibleUserFilterEmit = new EventEmitter<boolean>();
    changedVisibleUserFilter(increased: any) {
        this.changedVisibleUserFilterEmit.emit(increased);
    }

    @Input()
    public filterObj: any = {};

    public digitType = DigitTypeEnum;

    constructor() { }

    ngOnInit(): void {
    }

    public clickFilter() {
        this.customersComponent.filter = this.filterObj;
        this.customersComponent.getXpressUsers(0);
        this.cancel();
    }

    clear() {
        this.filterObj = {};
    }

    selectDigit(digit: DigitTypeEnum) {
        if (digit !== DigitTypeEnum.None) {
            this.filterObj.digitType = digit;
        }else{
            this.filterObj.digitType = null;
        }
    }

    cancel() {
        this.changedVisibleUserFilter(false);
    }
}
